import type { IAddressApi } from "../../application/interfaces/IAddressApi";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import type { AddressInput, AddressSuggestionDto, AddressVerifyDto, LocalityDto } from "../../shared/AddressDtos";

// Adress-Assistent: Address/Localities, Address/Suggest, Address/Verify
export class AddressApi implements IAddressApi {
  readonly configProvider: IAppConfigProvider;

  constructor(configProvider: IAppConfigProvider) {
    this.configProvider = configProvider;
  }

  async localities(countryCode: string, zip: string): Promise<LocalityDto[]> {
    const q = new URLSearchParams({ country: countryCode, zip });
    return (await this.get(`Address/Localities?${q}`)) as LocalityDto[];
  }

  async suggest(countryCode: string, query: string, zip: string, city: string, signal?: AbortSignal): Promise<AddressSuggestionDto[]> {
    const q = new URLSearchParams({ country: countryCode, q: query, zip, city });
    return (await this.get(`Address/Suggest?${q}`, signal)) as AddressSuggestionDto[];
  }

  async verify(address: AddressInput): Promise<AddressVerifyDto> {
    const config = await this.configProvider.getAppConfig();
    const response = await fetch(`${config.apiUrl}/Address/Verify`, {
      method: "POST",
      headers: { "X-Api-Key": config.apiKey, "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(address),
    });
    if (!response.ok) {
      return { state: "unavailable", message: "", match: null };
    }
    return (await response.json()) as AddressVerifyDto;
  }

  private async get(path: string, signal?: AbortSignal): Promise<unknown> {
    const config = await this.configProvider.getAppConfig();
    const response = await fetch(`${config.apiUrl}/${path}`, {
      headers: { "X-Api-Key": config.apiKey, Accept: "application/json" },
      signal,
    });
    if (!response.ok) {
      return [];
    }
    return await response.json();
  }
}
